var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFooterFixedBlog = function SvgIconFooterFixedBlog(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m10.776 11.224-1.697.602a.317.317 0 0 1-.405-.405l.602-1.697a.1.1 0 0 1 .016-.025l4.49-4.49a.57.57 0 0 1 .802 0l.707.707a.57.57 0 0 1 0 .802l-4.49 4.49a.1.1 0 0 1-.025.016m1.724-.3V12.5A1.5 1.5 0 0 1 11 14H3a1.5 1.5 0 0 1-1.5-1.5v-7h10.577L8.584 8.992a1.1 1.1 0 0 0-.252.398l-.602 1.696a1.318 1.318 0 0 0 1.683 1.682l1.696-.602c.15-.053 1.39-1.242 1.39-1.242M4 11.5h1.585a.5.5 0 0 0 0-1H4a.5.5 0 0 0 0 1m0-2h2.585a.5.5 0 0 0 0-1H4a.5.5 0 0 0 0 1m0-2h4.585a.5.5 0 0 0 0-1H4a.5.5 0 0 0 0 1m-2.5-3v-1A1.5 1.5 0 0 1 3 2h8a1.5 1.5 0 0 1 1.5 1.5v1z",
    clipRule: "evenodd"
  })));
};
export default SvgIconFooterFixedBlog;